import { render, staticRenderFns } from "./viewMaterial.vue?vue&type=template&id=62616599&"
import script from "./viewMaterial.vue?vue&type=script&lang=js&"
export * from "./viewMaterial.vue?vue&type=script&lang=js&"
import style0 from "./viewMaterial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports